var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivatedFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.88676 11.0619H2.68628",
    stroke: "#3B4858",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76025 4.60028H12.9607",
    stroke: "#3B4858",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81748 4.56417C5.81748 3.7004 5.11204 3 4.24206 3C3.37207 3 2.66663 3.7004 2.66663 4.56417C2.66663 5.42794 3.37207 6.12834 4.24206 6.12834C5.11204 6.12834 5.81748 5.42794 5.81748 4.56417Z",
    stroke: "#3B4858",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3332 11.0358C13.3332 10.1721 12.6283 9.47168 11.7583 9.47168C10.8878 9.47168 10.1824 10.1721 10.1824 11.0358C10.1824 11.8996 10.8878 12.6 11.7583 12.6C12.6283 12.6 13.3332 11.8996 13.3332 11.0358Z",
    stroke: "#3B4858",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivatedFilterIcon);
export default __webpack_public_path__ + "static/media/activated-filter-icon.c75722479c7d07a063cbd9e025c7e1ad.svg";
export { ForwardRef as ReactComponent };